export default __webpack_public_path__ + "media/images/close_tab_black-4a83c47cbab7528c22098c7822b5870a.png";